import React, { useEffect, useState } from 'react';
import SearchDropdown from '../../../app/partials/layout/SearchDropdown';
import UserProfile from '../../../app/partials/layout/UserProfile';
import UserNotifications from '../../../app/partials/layout/UserNotifications';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationItem } from '../../../app/store/action/NotifAction';
import { getNotifs } from '../../../app/store/action/NotifAction';
import { toAbsoluteUrl } from '../../../_metronic';
import NotificationsIcon from '@material-ui/icons/Notifications';

const Topbar = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { notifs, notSeenCount } = useSelector(state => state.notif);

  useEffect(() => {
    dispatch(getNotifs());
  }, []);

  const handleNotifyClick = async id => {
    const notifClicked = notifs.filter(notif => notif.id === id);
    !notifClicked[0].seen && (await dispatch(getNotificationItem(id)));
    setOpen(!open);
  };

  return (
    <div className="kt-header__topbar">
      <UserProfile showAvatar={true} showHi={true} showBadge={false} />
      {notifs && (
        <UserNotifications
          bgImage={toAbsoluteUrl('/media/misc/bg-1.jpg')}
          pulse={notSeenCount > 0}
          pulseLight={false}
          iconType=""
          type="success"
          useSVG={false}
          dot="false"
          icon={NotificationsIcon}
          notifs={notifs}
          count={notSeenCount}
          notifyOpen={open}
          handleClick={handleNotifyClick}
        />
      )}
    </div>
  );
};

export default Topbar;
